/**
 * campaign list 相关
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';
import { getDate } from 'src/utils/dateUtil';
import { isDiagnosisV2White } from 'src/const/whiteList';
import * as types from '../../types';

const SET_PERF_OPERATED_ANCHOR = `perf/${types.SET_PERF_OPERATED_ANCHOR}`;

export default {
  namespaced: true,
  state: {
    adgroupListToken: null,
    diagnosisDailyData: {},
  },
  mutations: {
    [types.SET_REQUEST_TOKEN](state, data) {
      state.adgroupListToken = data;
    },
    [types.SET_DIAGNOSIS_DAILY_DATA](state, data) {
      state.diagnosisDailyData = {
        ...state.diagnosisDailyData,
        ...Object.fromEntries(data.map(item => [item.ad_id, item])),
      };
    },
  },
  actions: {
    getAdReportStat(store, data) {
      return request.get(apis.ad.new_report_stat, data);
    },

    // 获取需要复制的计划信息
    getAdCopyInfo(store, data) {
      return request.get(apis.ad.copy, data);
    },

    // 获取 AdGroup 列表
    getAdGroupList({ state, commit }, data) {
      // 重复请求时清除之前的请求
      if (state.adgroupListToken) {
        state.adgroupListToken.cancel();
      }

      const cancelToken = request.axios.CancelToken;
      const source = cancelToken.source();
      commit(types.SET_REQUEST_TOKEN, source);
      return request.post(apis.ad.newStatisticList, data, {
        cancelToken: source.token,
      });
    },

    async loadDiagnosisDailyData({ commit, rootState }, adGroupIds) {
      if (!isDiagnosisV2White()) {
        return;
      }

      const { utcOffset } = rootState.account;
      const today = (typeof utcOffset === 'number' ? getDate()().utcOffset(utcOffset) : getDate()()).format('YYYY-MM-DD');
      const res = await request.post(apis.ad.newStatisticList, {
        ad_ids: adGroupIds,
        st: today,
        et: today,
        limit: 1000, // 设定一个极大值兼容不同列表分页大小
        query_list: ['stat_cost', 'time_attr_convert_cnt', 'time_attr_conversion_cost'],
      });

      const diagnosisDailyData = res.data.table.map((item) => {
        const { ad_id, stat_data } = item ?? {};
        const { stat_cost, time_attr_convert_cnt, time_attr_conversion_cost } = stat_data ?? {};
        return {
          ad_id, stat_cost, time_attr_convert_cnt, time_attr_conversion_cost,
        };
      });

      commit(types.SET_DIAGNOSIS_DAILY_DATA, diagnosisDailyData);
    },

    // 更改 AdGroup 状态
    updateAdStatus({ commit }, data) {
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.postForm(apis.ad.update_status, data);
    },

    // 修改出价
    updateAdBid({ commit }, requestData) {
      const { ad, data } = requestData;
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.postForm(apis.ad.update_bid(ad), data);
    },

    // 修改预算
    updateAdBudget({ commit }, requestData) {
      const { ad, data } = requestData;
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.postForm(apis.ad.update_budget(ad), data);
    },

    /** 修改定时预算 */
    updateAdScheduledBudget(store, { ad_id, data }) {
      return request.postForm(apis.ad.update_scheduled_budget(ad_id), data);
    },

    // 创建预览
    createAdPreview(store, data) {
      return request.postForm(apis.ad.preview_create, data);
    },

    // 获取预览二维码url
    getQrcodeUrl(store, data) {
      return request.postForm(apis.ad.preview_qr, data);
    },

    // 批量修改出价
    updateAdBatchBid({ commit }, data) {
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.postForm(apis.ad.batch_update_bid, data);
    },

    // split test一键放量
    splitTestToAll(store, data) {
      return request.postForm(apis.ad.splitTestToAll, data);
    },
    // split test关停实验
    splitTestStopTest(store, data) {
      return request.postForm(apis.ad.splitTestStopTest, data);
    },

  },
};
